import React from 'react';

// 리스트에서 클릭되는 비디오의 객제를 넘겨 받아서 세부 정보를 표현 하는 곳.
const CategoryList = ({ categoryList, selectedCategory, onSelectCategory }) => {
  //console.log("CategoryList", categoryList)

  const categoryList2 = categoryList.map((cat) => [cat, cat]);
  categoryList2.unshift(['전체', '']);

  const catList = categoryList && categoryList2.map(([cattitle, catval]) => {
    //const videoId = extractYouTubeVideoId(video.youtube_url);
    //return <VideoItem key={video.post_id} video={video} onSelectVideo={onSelectVideo} selectedVideo={selectedVideo}/>;
    return <a key={catval} className={`item ${selectedCategory === catval ? 'active' : ''}`} onClick={() => onSelectCategory(catval)}>
      {cattitle}</a>;
  });

  return (
    <div className="ui link list">
      {catList}
    </div>
  );
}

export default CategoryList;


